<template>
  <div>
    <el-upload
      ref="elupload"
      class="jui-upload"
      :action="group?upload_url+'?group_id='+group:upload_url"
      :limit="10"
      multiple
      :auto-upload="true"
      list-type="picture-card"
      :show-file-list="true"
      :headers="requestHeaders"
      :before-upload="beforeAvatarUpload"
      :on-preview="handlePictureCardPreview"
      :on-progress="handleProgress"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :on-exceed="uploadExceed"
    >
      <i class="el-icon-plus"></i>
      <div v-if="type === 'image'" slot="tip" class="el-upload__tip">只能上传 JPG/PNG/JPEG/GIF 格式文件，且不超过2MB,建议尺寸：800*800像素,最多上传10张</div>
      <div v-if="type === 'audio'" slot="tip" class="el-upload__tip">只能上传 MP3/WAV/WMA/MP4A 格式文件，且不超过10MB,最大上传数量 10 </div>
      <div v-if="type === 'video'" slot="tip" class="el-upload__tip">只能上传 AVI/MP4 格式文件，且不超过10MB,最大上传数量 10</div>
      <div v-if="type === 'document'" slot="tip" class="el-upload__tip">只能上传 PDF/XLSX/DOCX/RAR/ZIP 格式文件，且不超过10MB,最大上传数量 10</div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

  </div>
</template>
<script>
import { getToken } from '@/utils/auth'
export default {
  props: {
    type: { // 默认文件类型
      type: String,
      default: ''
    },
    group: { // 分组id
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      upload_url: process.env.VUE_APP_BASE_API + 'admin/Resources/Upload',
      requestHeaders: {
        'Authorization': 'Bearer ' + getToken()
      },
      MaxLimit: 10, // 上传限制MB,
      dialogVisible: false
    }
  },
  methods: {
    clearFiles() {
      this.$nextTick(res => {
        this.$refs['elupload'].clearFiles()
      })
    },
    uploadSuccess() {
      this.$emit('change')
    },
    uploadError() {
      this.$message.error('上传错误')
    },
    uploadExceed(files, fileList) {
      this.$message.error('超出了数量限制，最多10个')
    },
    beforeAvatarUpload(file) {
      const isType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isMaxLimit = file.size / 1024 / 1024 < this.MaxLimit
      var fileType = false
      if (this.type === 'image') {
        var image = ['png', 'jpg', 'jpeg', 'gif']
        if (image.toString().indexOf(isType) > -1) {
          fileType = true
        } else {
          this.$message.error('上传图片资源只能是 JPG/PNG/JPEG/GIF 格式!')
          return false
        }
      }

      if (this.type === 'audio') {
        var audio = ['mp3', 'mid', 'ogg', 'mp4', 'wav', 'wma', 'mp4a']
        if (audio.toString().indexOf(isType) > -1) {
          fileType = true
        } else {
          this.$message.error('上传音频资源只能是 MP3/WAV/WMA/MP4A 格式!')
          return false
        }
      }

      if (this.type === 'video') {
        var video = ['avi', 'mp4']
        if (video.toString().indexOf(isType) > -1) {
          fileType = true
        } else {
          this.$message.error('上传视频资源只能是 AVI/MP4 格式!')
          return false
        }
      }

      if (this.type === 'document') {
        var document = ['gz', 'tgz', 'bz', 'bz2', 'tbz', 'zip', 'rar', 'tar', '7z', 'xls', 'docx', 'xlsx', 'ppt', 'pps', 'pdf']
        if (document.toString().indexOf(isType) > -1) {
          fileType = true
        } else {
          this.$message.error('上传文件格式占不支持!')
          return false
        }
      }

      if (!isMaxLimit) {
        this.$message.error('上传资源文件大小不能超过 ' + this.MaxLimit + 'MB!')
        return false
      }
      return fileType && isMaxLimit
    },
    // 文件回显图
    handleProgress(event, file, fileList) {
      var SuccessFile = file.raw.name.split('.')
      if (['jpg', 'png', 'jpeg'].indexOf(SuccessFile[SuccessFile.length - 1].toLowerCase()) === -1) {
        console.log('fileList:', fileList)
        fileList[fileList.length - 1].url = require('@/assets/wenjian.png')
      }
    },
    handlePictureCardPreview() {
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss" >

</style>

